import React, { useState } from "react";
import ReactHtmlParser from "react-html-parser";

interface Props {
  selectedAnswer: any;
  question: any;
  answer: any;
  updateSelectedAnswer: (val: any) => void;
  submitAnswer: (e) => void;
  submitting: boolean;
  loadingAnswer: boolean;
  currentUser?: any;
}

const TextAction: React.FC<Props> = ({
  question,
  answer,
  selectedAnswer,
  updateSelectedAnswer,
  submitAnswer,
  submitting,
  loadingAnswer,
  currentUser,
}) => {
  const [feedback, setFeedback] = useState("");

  const handleChange = (e) => {
    setFeedback("");
    updateSelectedAnswer(e.target.value);
  };

  const handleSubmit = (e) => {
    if (!selectedAnswer || !String(selectedAnswer).trim()) {
      e.preventDefault();
      setFeedback("Type an answer before submitting.");
      return;
    }

    submitAnswer(e);
  };

  const translation = question?.translations?.find(
    (t) => t.language === currentUser?.locale,
  );

  return (
    <form className="q-card assignment-form">
      <div className="q-row">
        <span className="q-badge">Q</span>
        <div className="q-text">
          {ReactHtmlParser(
            translation
              ? translation?.formatted_description
              : question?.formatted_description,
          )}
        </div>
      </div>
      <div className="q-row q-answer">
        {(loadingAnswer || submitting) && (
          <div className="ui active inverted dimmer">
            <div className="ui text loader">Loading</div>
          </div>
        )}
        <span className="q-badge a">A</span>
        <div className="q-answer__body">
          {answer && (
            <p className="op-your">
              {ReactHtmlParser(answer.formatted_content || answer.content_url)}
            </p>
          )}
          {!answer && (
            <>
              <textarea
                className="q-textarea"
                placeholder="Type your answer, then submit..."
                value={selectedAnswer}
                onChange={(e) => handleChange(e)}
              />
              {/* "Mark as passed immediately" in admin: nobody marks it. */}
              {!question?.auto_pass && (
                <p className="q-hint">
                  A human marks this, usually within 45 minutes, often sooner.
                </p>
              )}
            </>
          )}
        </div>
      </div>
      {!answer && (
        <div className="q-actions">
          <span className={`q-feedback ${feedback ? "no" : ""}`}>
            {feedback}
          </span>
          <button
            className={`btn btn-blue btn--compact ${
              submitting ? "loading" : ""
            }`}
            type="submit"
            onClick={handleSubmit}
          >
            Submit answer
          </button>
        </div>
      )}
    </form>
  );
};

export default TextAction;
